import {useMutation} from '@tanstack/react-query';
import {postLoggingAccess} from '../services/postLoggingAccess';

export const useLoggingAccessMutation = () =>
	useMutation({
		mutationFn: postLoggingAccess,
	});
